import React from "react";
import cx from "classnames";
import styles from "../../scss/AFQuestionForm.module.scss";

const AFQuestionPlaceholder: React.FC = () => {
    return (
        <div
            className={cx([
                styles["app-question-form"]
            ])}>
            <div
                className={cx([
                    "layout-flex-column--centered",
                    styles["app-empty-question"]
                ])}>
                <div
                    className={cx([
                        styles["app-empty--title"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["app-empty--subtitle"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["app-empty--content"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["app-empty--content"],
                        styles["pre-loader"]
                    ])}></div>
                <div
                    className={cx([
                        styles["app-empty--action"],
                        styles["pre-loader"]
                    ])}></div>
            </div>
        </div>
    );
};

export default AFQuestionPlaceholder;
